const ItemReview = ({ content }) => {
	const image = content.image ? content.image : null;
	const name = content.name;
	const review = content.review;
	const className = content.image ? 'item-review__image' : 'item-review__image item-review__image_empty';

	return (
		<div className="reviews-main__item item-review">
			<div className="item-review__body">
				<div className={className}>
					{image && <img src={image} alt="" />}
				</div>
				<div className="item-review__name">{name}</div>
				<div className="item-review__review">{review}</div>
			</div>
		</div>
	)
}


export default ItemReview;